import uniq from 'lodash/uniq';
import * as Papa from 'papaparse';

import { ProjectFileUploadOptions } from 'src/store/state/projects';
import { formatSeparator } from 'src/utils/csv/formatSeparator';

export const doesFileHaveDuplicateHeaders =
  (fileOptions: ProjectFileUploadOptions) => (file: File | string) => {
    return new Promise<boolean>((resolve) => {
      const handleComplete: Papa.ParseConfig['complete'] = (results) => {
        const resultsFields = results.meta.fields?.sort();

        if (!resultsFields) {
          return resolve(true);
        }

        return resolve(resultsFields.length !== uniq(resultsFields).length);
      };

      const optionsToUse: Papa.ParseConfig = {
        complete: handleComplete,
        delimiter: formatSeparator(fileOptions.separator),
        escapeChar: fileOptions.escape,
        header: true,
        preview: 1,
        quoteChar: fileOptions.quote,
        skipEmptyLines: fileOptions.skipEmpty,
        step: (_, parser) => {
          parser.abort();
        },
      };

      Papa.parse(file as any, optionsToUse);
    });
  };
